import React from 'react';
import logo from "./../images/logo.svg";

const Footer = (props: any) => (
    <footer className="py-16 lg:py-24 bg-gray-50 dark:bg-gray-800 mt-20">
        <div className="w-full max-w-8xl mx-auto px-4">
            <div className="grid lg:grid-cols-6 gap-12 lg:gap-24">
                <div className="col-span-2">
                    <a href="https://flowbite.com" className="flex mb-6">
                        <img src={logo} className="h-10 mr-4" alt="Flowbite Logo" />
                        <span className="text-gray-900 dark:text-white self-center text-lg font-semibold">FlowBite</span>
                    </a>
                    <p className="text-gray-600 dark:text-gray-400">Flowbite is an ecosystem built around Tailwind CSS including Figma design files, an open-source component library and tools to help you accelerate your website development.</p>
                </div>
                <div>
                    <h3 className="text-gray-400 dark:text-white text-sm font-semibold uppercase mb-6">Resources</h3>
                    <ul>
                        <li className="mb-4">
                            <a href="https://themesberg.com?ref=flowbite.com" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Themesberg</a>
                        </li>
                        <li className="mb-4">
                            <a href="https://tailwindcss.com/?ref=flowbite.com" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Tailwind CSS</a>
                        </li>
                        <li className="mb-4">
                            <a href="https://www.figma.com/?ref=flowbite.com" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Figma</a>
                        </li>
                        <li className="mb-4">
                            <a href="https://themesberg.com/affiliate?ref=flowbite.com" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Affiliate program</a>
                        </li>
                    </ul>
                </div>
                <div>
                    <h3 className="text-gray-400 dark:text-white text-sm font-semibold uppercase mb-6">Help and support</h3>
                    <ul>
                        <li className="mb-4">
                            <a href="https://discord.gg/4eeurUVvTy" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Discord server</a>
                        </li>
                        <li className="mb-4">
                            <a href="https://github.com/themesberg/flowbite/discussions" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Github discussions</a>
                        </li>
                        <li className="mb-4">
                            <a href="https://themesberg.com/contact?ref=flowbite.com" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Contact us</a>
                        </li>
                        <li className="mb-4">
                            <a href="https://themesberg.com/knowledge-center?ref=flowbite.com" target="_blank"
                                rel="noreferrer nofollow" className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Knowledge Center</a>
                        </li>
                    </ul>
                </div>
                <div>
                    <h3 className="text-gray-400 dark:text-white text-sm font-semibold uppercase mb-6">Follow us</h3>
                    <ul>
                        <li className="mb-4">
                            <a href="https://github.com/themesberg" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Github</a>
                        </li>
                        <li className="mb-4">
                            <a href="https://twitter.com/themesberg" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Twitter</a>
                        </li>
                        <li className="mb-4">
                            <a href="https://www.facebook.com/themesberg" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Facebook</a>
                        </li>
                        <li className="mb-4">
                            <a href="https://ro.linkedin.com/company/themesberg" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">LinkedIn</a>
                        </li>
                    </ul>
                </div>
                <div>
                    <h3 className="text-gray-400 dark:text-white text-sm font-semibold uppercase mb-6">Legal</h3>
                    <ul>
                        <li className="mb-4">
                            <a href="https://themesberg.com/privacy-policy" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Privacy Policy</a>
                        </li>
                        <li className="mb-4">
                            <a href="https://themesberg.com/terms-and-conditions" target="_blank" rel="noreferrer nofollow"
                                className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Terms & Conditions</a>
                        </li>
                        <li className="mb-4">
                            <a href="https://flowbite.com/license" className="text-gray-600 dark:text-gray-400 dark:hover:text-white font-normal hover:underline">Licensing</a>
                        </li>
                    </ul>
                </div>
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-8 lg:my-12" />
            <span className="block text-center text-gray-600 dark:text-gray-400 font-">© 2019-{new Date().getFullYear()} <a href="https://themesberg.com" target="_blank" rel="noreferrer">Themesberg</a>. All Rights Reserved.</span>
        </div>
    </footer>
);

export default Footer;
